var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "mb-5 last:mb-0 md:max-w-xxs md:mx-auto" }, [
    _vm.label
      ? _c("label", { staticClass: "text-base mb-2 flex w-auto items-start" }, [
          _vm._v("\n    " + _vm._s(_vm.label) + "\n    "),
          _vm.isRequired
            ? _c("span", { staticClass: "text-velux-red ml-0.5" }, [
                _vm._v("*")
              ])
            : _vm._e()
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "select",
      {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.model.select,
            expression: "model.select"
          }
        ],
        staticClass:
          "\n      px-4\n      w-full\n      py-3.5\n      md:p-3\n      text-base\n      md:text-lg\n      border\n      placeholder-velux-grey-300\n      font-bold\n    ",
        class: {
          "border-velux-red": _vm.hasError()
        },
        attrs: { name: _vm.name, id: _vm.id },
        on: {
          blur: function($event) {
            return _vm.handleValidation({ isBlur: true })
          },
          change: [
            function($event) {
              var $$selectedVal = Array.prototype.filter
                .call($event.target.options, function(o) {
                  return o.selected
                })
                .map(function(o) {
                  var val = "_value" in o ? o._value : o.value
                  return val
                })
              _vm.$set(
                _vm.model,
                "select",
                $event.target.multiple ? $$selectedVal : $$selectedVal[0]
              )
            },
            function($event) {
              _vm.handleValidation()
              _vm.handleInput($event)
            }
          ]
        }
      },
      [
        _vm.placeholder
          ? _c(
              "option",
              { attrs: { value: "" }, domProps: { selected: _vm.placeholder } },
              [_vm._v("\n      " + _vm._s(_vm.placeholder) + "\n    ")]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm._l(_vm.options(), function(option, index) {
          return _c("option", { key: index, domProps: { value: option.key } }, [
            _vm._v("\n      " + _vm._s(option.value) + "\n    ")
          ])
        })
      ],
      2
    ),
    _vm._v(" "),
    _vm.hasError() && _vm.errorMessage
      ? _c(
          "div",
          { staticClass: "text-velux-red mt-1 font-bold text-left text-base" },
          [_vm._v("\n    " + _vm._s(_vm.errorMessage) + "\n  ")]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }